<template>
  <div class="root">
    <div class="video__container">
      <div class="video__container__header">
        <button class="button-close" @click="showChart">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <div class="video__container__top">
        <div class="video__container__left">
          <div class="quick-play-section">
            <div class="title">Quick Play Video</div>
            <input
              type="text"
              class="input background-items"
              placeholder="https://www.youtube.com/watch?v=..."
              v-model="quickPlayUrl"
              @keyup.enter="quickPlay(quickPlayUrl)"
            />
            <button class="quick-play-button" @click="quickPlay(quickPlayUrl)">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="0" style="margin-right: 6px;">
                <polygon points="5,3 19,12 5,21" fill="currentColor"/>
              </svg>
              Play Now
            </button>
          </div>
        </div>
        <div class="video__container__right">
          <div class="add-section">
            <div class="title">Add Video/Playlist to Library</div>
            <input
              type="text"
              class="input background-items"
              placeholder="https://www.youtube.com/watch?v=... or https://www.youtube.com/playlist?list=..."
              v-model="addUrl"
              @keyup.enter="addVideo(addUrl)"
            />
            <button class="add-video-button" @click="addVideo(addUrl)">Add to Library</button>
          </div>
        </div>
      </div>
      <div class="video__container__bottom">
        <div class="library-section">
          <div class="title">Your Video Library</div>
          <div class="list_wrapper">
          <div v-if="!videoList.length && user.isLogged" class="list_wrapper_noVideos">
            You have not added any video yet
          </div>
          <div class="list_container" v-for="(video, index) in videoListValue" :key="index">
            <div class="list__item__row">
              <button class="list__item__play-button" @click.stop="sendVideoUrl(index)">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="0">
                  <polygon points="5,3 19,12 5,21" fill="currentColor"/>
                </svg>
              </button>
              <div @click.stop="sendVideoUrl(index)" class="list__item background-items">
                <div
                  class="list__item__preview-pic"
                  :class="{
                    'is-preview-icon': !video.previewImageUrl,
                    'is-playlist': video.type === 'playlist'
                  }"
                  :style="{ 'background-image': `url(${video.previewImageUrl})`}">
                  <svg-icon v-if="!video.previewImageUrl" :icon="video.type === 'playlist' ? 'playlist' : 'youtube'"/>
                  
                  <div v-if="video.type === 'playlist'" class="playlist-indicator">
                    <svg-icon icon="playlist" class="playlist-icon"/>
                    <span class="playlist-count">{{ video.videoCount || video.videos?.length || 0 }}</span>
                  </div>
                </div>
                <div class="list__item__info">
                  <div class="list__item__title">{{ video.title }}</div>
                  <div class="list__item__time">{{ video.duration }}</div>
                </div>
                <button
                  v-if="
                    user.isLogged && video.title != '30 Second Sprints HIIT Sandwich Session | Indoor Cycling Workout'
                  "
                  class="list__item__delete"
                  @click.stop="deleteVideo(video.url)"
                >
                  <ButtonDelete />
                </button>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ButtonBack from '@/components/ButtonBack'
  import ButtonDelete from '@/components/ButtonDelete'
  import SVGIcon from '@/components/SVGIcon'
  import { mapState, mapActions } from 'vuex'
  import VueCookies from 'vue-cookies'

  export default {
    data() {
      return {
        quickPlayUrl: '',
        addUrl: ''
      }
    },
    components: {
      ButtonBack,
      ButtonDelete,
      SVGIcon
    },
    props: ['youtubeFrame'],
    name: 'VideosList',
    computed: {
      ...mapState(['videoList', 'user']),
      videoListValue() {
        return this.videoList
      }
    },

    async mounted() {
      this.token = VueCookies.get('token')
    },
    methods: {
      ...mapActions(['getVideoList', 'addVideo', 'showChart']),
      swapComponent() {
        this.$emit('clickToSwapComponent')
      },
      showChart() {
        this.$store.dispatch('showChart')
      },
      async addVideo(inputUrl) {
        if (inputUrl === '') {
          await this.checkAddError("Link can't be empty")
          return
        }

        // Check if it's a playlist URL
        const isPlaylist = this.isPlaylistUrl(inputUrl)

        const isVideoExist = this.videoList.find((el) => {
          return inputUrl.includes(el.url)
        })

        if (!isVideoExist) {
          const actionType = isPlaylist ? 'addPlaylist' : 'addVideo'
          const { title } = await this.$store.dispatch(actionType, inputUrl)
          if (title === 'Error' || title === 'TypeError' || !title) {
            await this.checkAddError('Link not valid')
          }
        } else {
          await this.checkAddError(isPlaylist ? 'Playlist already exist' : 'Video already exist')
        }
        this.addUrl = ''
      },
      isPlaylistUrl(url) {
        return url.includes('playlist?list=') || url.includes('list=')
      },
      async checkAddError(errorText) {
        this.addUrl = errorText
        await new Promise((resolve) => setTimeout(resolve, 1000))
        setTimeout(() => {
          this.addUrl = ''
        }, 0)
      },
      
      async checkQuickPlayError(errorText) {
        this.quickPlayUrl = errorText
        await new Promise((resolve) => setTimeout(resolve, 1000))
        setTimeout(() => {
          this.quickPlayUrl = ''
        }, 0)
      },
      async deleteVideo(url) {
        await this.$store.dispatch('deleteVideo', url)
      },
      sendVideoUrl(index) {
        const video = this.videoList[index]
        if (video.type === 'playlist') {
          // Send the current video in the playlist
          const currentVideoIndex = video.currentIndex || 0
          const currentVideo = video.videos[currentVideoIndex]
          if (currentVideo) {
            this.$emit('videoUrl', currentVideo.url)
            this.$emit('playlistData', { index, currentIndex: currentVideoIndex, video })
          }
        } else {
          this.$emit('videoUrl', video.url)
        }
      },
      
      async quickPlay(inputUrl) {
        if (inputUrl === '') {
          await this.checkQuickPlayError("Link can't be empty")
          return
        }
        
        // Validate URL format
        if (!inputUrl.includes('youtube.com') && !inputUrl.includes('youtu.be')) {
          await this.checkQuickPlayError('Please enter a valid YouTube URL')
          return
        }
        
        // Directly emit the URL to play without adding to library
        this.$emit('videoUrl', inputUrl)
        this.quickPlayUrl = ''
      }
    }
  }
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@500&display=swap");
@import "../assets/styles/videoList.css";
</style>
